var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-col",
    {
      attrs: { tag: "a", sm: "6", md: "4", lg: "3", xl: "2" },
      on: { click: _vm.showBuyModal },
    },
    [
      _c(
        "b-card",
        {
          attrs: { "header-class": "aspect-1-1" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "aspect-box" }, [
                    _c(
                      "picture",
                      [
                        _c("source", {
                          attrs: {
                            srcset: `${_vm.product.images[0].src}.webp`,
                            type: "image/webp",
                          },
                        }),
                        _c("source", {
                          attrs: {
                            srcset: `${_vm.product.images[0].src}.jpg`,
                            type: "image/jpeg",
                          },
                        }),
                        _c("b-img", {
                          attrs: {
                            src: `${_vm.product.images[0].src}.jpg`,
                            alt: _vm.product.images[0].alt,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.product.name))]),
          _vm.product.sheet
            ? _c("small", [
                _vm._v(
                  "Sheet Size: " +
                    _vm._s(_vm.product.sheet.width_mm) +
                    "x" +
                    _vm._s(_vm.product.sheet.height_mm) +
                    "mm"
                ),
                _c("br"),
                _vm._v("£" + _vm._s(_vm.product.price) + " per sheet"),
              ])
            : _vm.product.unit
            ? _c("small", [
                _vm._v(_vm._s(_vm.product.unit.bulk_quantity) + " per box"),
                _c("br"),
                _vm._v("£" + _vm._s(_vm.product.price) + " per box"),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalId,
            size: "xl",
            "hide-footer": "",
            title: _vm.product.name,
            lazy: "",
          },
          on: { show: _vm.getPrice },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3 mb-lg-0", attrs: { lg: "6" } },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "picture",
                      [
                        _c("source", {
                          attrs: {
                            srcset: `${_vm.product.images[0].src}.webp`,
                            type: "image/webp",
                          },
                        }),
                        _c("source", {
                          attrs: {
                            srcset: `${_vm.product.images[0].src}.jpg`,
                            type: "image/jpg",
                          },
                        }),
                        _c("b-img", {
                          staticClass: "mb-3",
                          attrs: {
                            src: `${_vm.product.images[0].src}.jpg`,
                            alt: _vm.product.images[0].alt,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.discounts.length > 0
                    ? _c("discounts-breakdown", {
                        attrs: {
                          "item-type": _vm.product.sheet ? `Sheet` : `Unit`,
                          discounts: _vm.discounts,
                          loading: _vm.loadingDiscounts,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { lg: "6" } },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.product.meta.parsed_page),
                    },
                  }),
                  _vm.product.sheet
                    ? _c("div", { staticClass: "sheet-info" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _c("strong", [_vm._v("Sheet Width:")]),
                          _vm._v(
                            " " + _vm._s(_vm.product.sheet.width_mm) + "mm"
                          ),
                        ]),
                        _c("p", { staticClass: "mb-1" }, [
                          _c("strong", [_vm._v("Sheet Height:")]),
                          _vm._v(
                            " " + _vm._s(_vm.product.sheet.height_mm) + "mm"
                          ),
                        ]),
                        _c("p", { staticClass: "mb-1" }, [
                          _c("strong", [_vm._v("Sheet Depth:")]),
                          _vm._v(
                            " " + _vm._s(_vm.product.sheet.depth_mm) + "mm"
                          ),
                        ]),
                      ])
                    : _vm.product.unit
                    ? _c("div", { staticClass: "unit-info" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _c("strong", [_vm._v("Quantity in Box:")]),
                          _vm._v(" " + _vm._s(_vm.product.unit.bulk_quantity)),
                        ]),
                      ])
                    : _vm._e(),
                  _c("hr"),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Quantity:", "label-size": "lg" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "number",
                          number: "",
                          step: "1",
                          min: "1",
                          size: "lg",
                        },
                        model: {
                          value: _vm.quantity,
                          callback: function ($$v) {
                            _vm.quantity = $$v
                          },
                          expression: "quantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: !_vm.delivery.isValid,
                        variant: "warning",
                      },
                    },
                    [
                      _vm._v(
                        "This item is available for collection only from our showroom."
                      ),
                    ]
                  ),
                  _c("b-overlay", { attrs: { show: _vm.loadingPrice } }, [
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              href: _vm.moreInfoLink,
                              variant: "info",
                              size: "lg",
                            },
                          },
                          [_vm._v("More Info")]
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "ml-2 mb-2",
                            attrs: {
                              size: "lg",
                              variant: _vm.buyButtonVariant,
                              disabled: _vm.isAddToCartDisabled,
                            },
                            on: { click: _vm.addToCart },
                          },
                          [
                            _vm._v(
                              "Add to Cart (£" +
                                _vm._s(_vm.pricing.total_price) +
                                ")"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }